import { render, staticRenderFns } from "./ProfileIconDropdown.vue?vue&type=template&id=2324c761&scoped=true&"
import script from "./ProfileIconDropdown.vue?vue&type=script&lang=js&"
export * from "./ProfileIconDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIconDropdown.vue?vue&type=style&index=0&id=2324c761&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2324c761",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu})
